<template>
  <div>
    <div class="contents">
      <BaseHeader title="ログ一覧" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Log',
  components: {
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/system/LogTop.vue